import { useEffect } from "react";
import Lenis from "@studio-freight/lenis";

/**
 * Mounts a single Lenis smooth-scroll instance for the whole site
 * and exposes it on window so ScrollToTop can bypass smooth scroll
 * on route changes.
 */
export default function SmoothScroll() {
    useEffect(() => {
        const prefersReduced = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
        ).matches;
        if (prefersReduced) return;

        const lenis = new Lenis({
            duration: 1.05,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            smoothTouch: false,
        });

        // Expose so ScrollToTop can call lenis.scrollTo(0, { immediate: true })
        window.__lenis = lenis;

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            if (window.__lenis === lenis) delete window.__lenis;
        };
    }, []);
    return null;
}
